import { render, staticRenderFns } from "./agentInfo.vue?vue&type=template&id=3bcdf836&scoped=true"
import script from "./agentInfo.vue?vue&type=script&lang=js"
export * from "./agentInfo.vue?vue&type=script&lang=js"
import style0 from "./agentInfo.vue?vue&type=style&index=0&id=3bcdf836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcdf836",
  null
  
)

export default component.exports